import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { UserRelationshipGroup, UserRelationshipData } from '../../models';
import * as _ from 'lodash';
import { UserRelationshipService } from '../../user-relationship.service';
import { containsElement } from '@angular/animations/browser/src/render/shared';

@Component({
  selector: 'app-inactivate-user',
  templateUrl: './inactivate-user.component.html',
  styleUrls: ['./inactivate-user.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InactivateUserComponent implements OnInit {
  @Input() displayDialog: boolean;
  @Input() userRelationship: UserRelationshipGroup;

  @Output() onDialogClose = new EventEmitter<boolean>();
  @Output() onEditUser = new EventEmitter<UserRelationshipGroup[]>();
  @Output() onMessage = new EventEmitter<any>();

  processing = false;
  relationshipAndContactId: any[];
  isPrimaryContactSelected = false;
  userRelationshipGroup: UserRelationshipGroup;
  constructor( private userRelationshipSvc: UserRelationshipService) { }

  ngOnInit() {
    this.userRelationshipGroup = _.cloneDeep(this.userRelationship);
    console.log(this.userRelationshipGroup);
  }

  onSubmit() {
    if (this.isPrimaryContactSelected) {
      this.processing = true;
      this.processFormdata();
      this.userRelationshipSvc.update([this.userRelationshipGroup])
        .subscribe((user: any) => {
          this.onEditUser.emit(user.data);
          this.processing = false;
          this.displayDialog = false;
      }, error => {
        this.processing = false;
        this.displayDialog = false;
        this.onMessage.emit({severity: 'error', summary: 'Error Occcured while Processing'});
      });
    }
  }

  /* check user relationship update with proper new primary contact */
  processFormdata(): void {
    this.userRelationshipGroup.PersonDetail.IsActive = false;
    this.userRelationshipGroup.PersonDetail.LoginEnabled = false;
    this.relationshipAndContactId.map(primaryConact => {
      this.userRelationshipGroup.Relationship.map((userRelationshipData: UserRelationshipData, index) => {
        if (primaryConact.RelationshipId === userRelationshipData.Id) {
          this.userRelationshipGroup.Relationship[index].NewPrimaryContactId = primaryConact.NewPrimaryContactId;
        }
      });
    });
  }

  dialogClose() {
    this.onDialogClose.emit(false);
  }

  /* New primary contact with RelationshipID */
  mapRelationshipAndContactId(relationshipAndContactId: []): void {
    this.relationshipAndContactId = relationshipAndContactId;
  }

  /* New Primary contact dropdown is valid or not */
  checkIsPrimaryContactReady(isPrimaryContactReady: boolean): void {
    this.isPrimaryContactSelected = typeof isPrimaryContactReady === 'undefined' ? true : isPrimaryContactReady;
  }

}
